import React from 'react'

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const genericMemo = <T extends React.ComponentType<any>>(
    innerComponent: T,
    propsAreEqual?: (
        prevProps: Readonly<React.ComponentProps<T>>,
        nextProps: Readonly<React.ComponentProps<T>>
    ) => boolean
): typeof innerComponent =>
    React.memo(
        innerComponent,
        propsAreEqual
    ) as unknown as typeof innerComponent
